module.exports = __webpack_public_path__ + "img/kcidea-icon.40324eb8.png";